import ContentfulMixin from '@Shared/mixins/contentful'

const V2Contentful = {
  install (Vue, options) {
    Vue.mixin(
      ContentfulMixin
    )
  }
}

export default V2Contentful



// WEBPACK FOOTER //
// ./WebResources/vue/shared/plugins/V2Contentful.js